import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/SellerDashboard.css';

const SellerSalesStats = ({ pointOfSaleId }) => {
  const [salesStats, setSalesStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSalesStats = async () => {
      if (!pointOfSaleId) return;
      
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        console.log('Obteniendo estadísticas de ventas para el punto de venta:', pointOfSaleId);
        
        // Usar el endpoint existente para obtener estadísticas de ventas por punto de venta
        const response = await axios.get(`/api/stats/sales/${pointOfSaleId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        console.log('Estadísticas de ventas obtenidas:', response.data);
        setSalesStats(response.data);
        setError(null);
      } catch (error) {
        console.error('Error al obtener estadísticas de ventas:', error);
        setError('Error al cargar estadísticas de ventas');
      } finally {
        setLoading(false);
      }
    };

    fetchSalesStats();
  }, [pointOfSaleId]);

  if (loading) {
    return <div className="loading-message">Cargando estadísticas...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  // Mostrar las estadísticas incluso cuando son cero
  // Solo mostrar mensaje de no disponible si realmente no hay datos
  if (!salesStats) {
    return <div className="empty-message">No hay estadísticas de ventas disponibles.</div>;
  }

  return (
    <div className="seller-stats-container">
      <h2>Estadísticas de Ventas</h2>
      <div className="seller-stats-grid">
        <div className="seller-stat-card">
          <h3>Ventas de Hoy</h3>
          <p className="stat-value">${salesStats.todaySales?.toFixed(2) || '0.00'}</p>
        </div>
        <div className="seller-stat-card">
          <h3>Ventas del Mes</h3>
          <p className="stat-value">${salesStats.monthSales?.toFixed(2) || '0.00'}</p>
        </div>
        <div className="seller-stat-card">
          <h3>Ticket Promedio</h3>
          <p className="stat-value">${salesStats.monthSales && salesStats.monthTransactions ? (salesStats.monthSales / salesStats.monthTransactions).toFixed(2) : '0.00'}</p>
        </div>
      </div>
    </div>
  );
};

export default SellerSalesStats;
